import { Router } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { SideNavMenu } from 'src/app/models/side-nav-menu.model';

@Component({
    selector: 'app-side-nav-menu',
    templateUrl: './side-nav-menu.component.html',
    styleUrls: ['./side-nav-menu.component.scss']
})
export class SideNavMenuComponent implements OnInit {

    @Input()
    menu: SideNavMenu;

    constructor(
        private router: Router
    ) {}

    isSelected(menu: SideNavMenu) {
        const queryParamsLocation = this.router.url.search(/\?/);
        const routerSteps = this.router.url.substring(0, queryParamsLocation !== -1 ? queryParamsLocation : this.router.url.length).split('/').filter(route => !!route);
        const selected = menu.redirect?.every((route, i) => i < routerSteps.length && route === routerSteps[i]);
        return selected || menu.submenus?.some(submenu => this.isSelected(submenu));
    }

    ngOnInit() {
    }

}
